import { useQuery } from "@tanstack/react-query";
import { Venue } from "../../types/venue";

export const fetchVenueHours = async (id: string): Promise<Venue> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/venues/${id}/hours`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch venue by id");
  }

  const data = await response.json();
  return data.hours;
};

export const useGetVenueHours = (id?: string) => {
  return useQuery(["venue-hours", id], () => fetchVenueHours(id!), {
    enabled: !!id,
  });
};
